var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "editor-wrapper",
    style: Object.assign({
      border: '1px solid #000'
    }, _vm.rootStyles ? _vm.rootStyles : {})
  }, [_vm.editor ? _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "actions-container"
  }, [_c('svg', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('bold')
    },
    attrs: {
      "role": "button",
      "aria-pressed": _vm.editor.isActive('bold') ? 'true' : 'false',
      "tabindex": "10",
      "height": "30",
      "width": "30",
      "aria-label": "Bold",
      "disabled": !_vm.editor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.boldSvg)
    },
    on: {
      "click": _vm.toggleBold,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleBold($event);
      }
    }
  }), _c('svg', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('italic')
    },
    attrs: {
      "role": "button",
      "aria-pressed": _vm.editor.isActive('italic') ? 'true' : 'false',
      "tabindex": "10",
      "height": "30",
      "width": "30",
      "aria-label": "Italic",
      "disabled": !_vm.editor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.italicSvg)
    },
    on: {
      "click": _vm.toggleItalic,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleItalic($event);
      }
    }
  }), _c('svg', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('underline')
    },
    attrs: {
      "height": "30",
      "tabindex": "10",
      "width": "30",
      "aria-label": "Underline",
      "id": "text-editor-underline-button",
      "role": "button",
      "aria-pressed": _vm.editor.isActive('underline') ? 'true' : 'false',
      "disabled": !_vm.editor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.underlineSvg)
    },
    on: {
      "click": _vm.toggleUnderline,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleUnderline($event);
      }
    }
  })]), _vm.showMaxLength ? _c('label', {
    staticClass: "max-length-container",
    attrs: {
      "role": "status",
      "for": "text-area"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.editor.storage.characterCount.characters()) + " of " + _vm._s(_vm.maxLength) + "\n    ")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "editor-container",
    class: {
      isMobile: _vm.isMobile
    }
  }, [_c('editor-content', {
    attrs: {
      "editor": _vm.editor,
      "id": "text-area",
      "tabindex": "10"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }